/** The server's limits (ALLOWED_VIDEO_MIME_TYPES, MAX_VIDEO_SIZE_BYTES). */
const VIDEO_TYPES = ['video/mp4', 'video/webm', 'video/quicktime'];
const MAX_VIDEO_BYTES = 50 * 1024 * 1024;

/** Why a picked file cannot be the video, or null when it can. */
export function videoFileError(file) {
  if (!VIDEO_TYPES.includes(file.type)) return 'Upload an MP4, WebM or MOV video.';
  if (file.size > MAX_VIDEO_BYTES) return 'The video is too large. The limit is 50 MB.';
  return null;
}
